module.exports = __webpack_public_path__ + "static/media/TaskManager.4acac81d.png";